// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_Q1H7P","actionLine":"index_actionLine_tjBw8","returnBackBtn":"index_returnBackBtn_rzL7h","shareBtn":"index_shareBtn_T2GPu"};